import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import SearchEpisode from "./SearchEpisode";
import Heroicon from "./Heroicon";

function SelectSinglePlayer({ episodeTitle, episodeId, podcastId, iframeUrl }) {

    const [currentEpisodeId, setCurrentEpisodeId] = useState(episodeId);
    const iframeSrc = iframeUrl + currentEpisodeId;
    const iframeText = `<iframe class="castos-iframe-player" src="${iframeSrc}" width="100%" height="150"></iframe>`;

    return (
        <>
            <SearchEpisode podcastId={podcastId} value={episodeTitle} handleChange={(episode) => setCurrentEpisodeId(episode.id)} />
            <iframe id="episode_player_iframe" className="castos-iframe-player mt-4" src={iframeSrc} width="100%" height="150"></iframe>
            <code>
                <textarea id="episode_player_code" readOnly rows="2" className="mt-4 p-4 text-sm sm:text-base text-purple-600 bg-purple-100 border border-purple-300 w-full resize-none rounded-md font-sans" value={iframeText}></textarea>
            </code>
            <button 
              id="copy_single_player" 
              className="btn-solid btn-primary mt-2 text-sm sm:text-base flex items-center gap-2"
              onClick={() => {
                document.getElementById("episode_player_code").select()
                navigator.clipboard.writeText(iframeText)
              }}
            >
              <Heroicon icon="o-clipboard-document" style="h-5 w-5" />
              Copy
            </button>
        </>
    );
}

const initSelectSinglePlayer = function(selector) {
  const elements = document.querySelectorAll(selector);
  if (elements.length > 0) {
    elements.forEach(element => {
      const root = createRoot(element);
      const episodeTitle = element.dataset.episodetitle;
      const episodeId = element.dataset.episodeid;
      const podcastId = element.dataset.podcastid;
      const iframeUrl = element.dataset.iframeurl;
      root.render(<SelectSinglePlayer episodeTitle={episodeTitle} episodeId={episodeId} podcastId={podcastId} iframeUrl={iframeUrl} />);
    });
  }
};

export { SelectSinglePlayer as default, initSelectSinglePlayer };
